iScreenWizard.controller('MatchingController', function ($scope, $state, $mdDialog, Ajax, Dictionary, userService, Opleidingsniveau, Opleidingsgroep, Gebruiker, Testafname, Competentieprofiel, Matchingintellectuelecompetentieoptie, p2cService, c2pService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.c2p = c2pService;
    $scope.p2c = p2cService;

    $scope.matchingType = '';
    $scope.showFilter = false;

    $scope.opleidingsniveaus = [];
    $scope.opleidingsgroepen = [];
    $scope.matchingintellectuelecompetentieopties = [];
    $scope.gebruikers = [];

    $scope.testafnames = [];
    $scope.testafnameFilters = {
        kandidaat_naam: '',
        kandidaat_opleidingsniveau_id: '!',
        testcode: '',
        opleidingsniveau_id: '!',
        aanmaakdatum: '',
    };
    $scope.testafnamePage = 1;
    $scope.testafnameMorePages = true;

    $scope.competentieprofielen = [];
    $scope.competentieprofielFilters = {
        titel: '',
        gebruiker_naam: '',
        omschrijving: ''
    };
    $scope.competentieprofielPage = 1;
    $scope.competentieprofielMorePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
        $scope.loadCompetentieprofielen();
    });

    $scope.refresh = function() {
        p2cService.model = {};
        p2cService.SaveState();
        c2pService.model = {};
        c2pService.SaveState();

        Opleidingsniveau.all().then(function (opleidingsniveaus) {
            $scope.opleidingsniveaus = opleidingsniveaus;
        });
        Opleidingsgroep.all().then(function (opleidingsgroepen) {
            $scope.opleidingsgroepen = opleidingsgroepen;
        });
        Gebruiker.all().then(function (gebruikers) {
            $scope.gebruikers = gebruikers;
        });
        Matchingintellectuelecompetentieoptie.all().then(function (matchingintellectuelecompetentieopties) {
            $scope.matchingintellectuelecompetentieopties = matchingintellectuelecompetentieopties;
        });
    };

    $scope.filterTestafnames = function() {
        $scope.testafnames = [];
        $scope.testafnameMorePages = true;
        $scope.testafnamePage = 1;
        $scope.loadTestafnames();
    };

    $scope.loadMoreTestafnames = function() {
        $scope.testafnamePage = $scope.testafnamePage+1;
        $scope.loadTestafnames();
    };

    $scope.loadTestafnames = function() {
        params = {
            pagesize: pagesize,
            page: $scope.testafnamePage,
            als_matching_bron: 1,
            matching_intellectuele_competentie_optie: $scope.c2p.model.intellectuele_competentie_optie
        };
        if ($scope.testafnameFilters.kandidaat_naam.length > 0) {
            params.kandidaat_naam = $scope.testafnameFilters.kandidaat_naam;
        }
        if ($scope.testafnameFilters.kandidaat_opleidingsniveau_id > 0) {
            params.kandidaat_opleidingsniveau_id = $scope.testafnameFilters.kandidaat_opleidingsniveau_id;
        }
        if ($scope.testafnameFilters.testcode.length > 0) {
            params.testcode = $scope.testafnameFilters.testcode;
        }
        if ($scope.testafnameFilters.opleidingsniveau_id > 0) {
            params.opleidingsniveau_id = $scope.testafnameFilters.opleidingsniveau_id;
        }
        if ($scope.testafnameFilters.aanmaakdatum) {
            params.aanmaakdatum = moment($scope.testafnameFilters.aanmaakdatum).format('DD-MM-YYYY');
        }
        Testafname.all(params).then(function (testafnames) {
            angular.forEach(testafnames, function(testafname) {
                $scope.testafnames.push(testafname);
            });
            if (testafnames.length < pagesize) {
                $scope.testafnameMorePages = false;
            }
        });
    };

    $scope.filterCompetentieprofielen = function() {
        $scope.competentieprofielen = [];
        $scope.competentieprofielMorePages = true;
        $scope.competentieprofielPage = 1;
        $scope.loadCompetentieprofielen();
    };

    $scope.loadMoreCompetentieprofielen = function() {
        $scope.competentieprofielPage = $scope.competentieprofielPage+1;
        $scope.loadCompetentieprofielen();
    };

    $scope.loadCompetentieprofielen = function() {
        params = {
            pagesize: pagesize,
            page: $scope.competentieprofielPage
        };
        if ($scope.competentieprofielFilters.titel.length > 0) {
            params.titel = $scope.competentieprofielFilters.titel;
        }
        if ($scope.competentieprofielFilters.gebruiker_naam.length > 0) {
            params.gebruiker_naam = $scope.competentieprofielFilters.gebruiker_naam;
        }
        if ($scope.competentieprofielFilters.omschrijving.length > 0) {
            params.omschrijving = $scope.competentieprofielFilters.omschrijving;
        }
        Competentieprofiel.all(params).then(function (competentieprofielen) {
            angular.forEach(competentieprofielen, function(competentieprofiel) {
                $scope.competentieprofielen.push(competentieprofiel);
            });
            if (competentieprofielen.length < pagesize) {
                $scope.competentieprofielMorePages = false;
            }
        });
    };

    $scope.selectCompetentieprofiel = function(competentieprofiel) {
        p2cService.model.competentieprofiel = competentieprofiel;
        p2cService.SaveState();
        $state.go('matching/p2c/testafnames');
    };

    $scope.selectTestafname = function(testafname) {
        c2pService.model.testafname = testafname;
        c2pService.SaveState();
        if (c2pService.model.intellectuele_competentie_optie != 3) {
            $state.go('matching/c2p/competentieprofielen');
        } else {
            $state.go('matching/c2p/ideaalscores');
        }
    };

    $scope.getTrainingGroupWithId = function(array, id) {
        var match = null;
        angular.forEach(array, function(object, index) {
            if (object.id === id) {
                match = object;
            }
        });
        return match;
    }
});